define('extensions/knockout/functions/nullIfDefault', [
    'knockout'
], (ko) => {
    ko.subscribable.fn.nullIfDefault = function (value) {
        return ko.pureComputed(() => this() == value ? null : this());
    };
});